import { Component, Input, OnInit } from '@angular/core';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { NavService } from '../../_services/_nav.service';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Segmento } from '../../_models/segmento';
import { ProductoService } from '../../_services/producto.service';
import { forkJoin, Observable } from 'rxjs';
import { ListaService } from '../../_services/lista.service';
import { ListaItem } from '../../_models/lista-item';
import { SegmentoActivo } from '../../_models/segmento-activo';
import { SegmentoActivoService } from '../../_services/segmento-activo.service';
import { SegmentoSectorService } from '../../_services/segmento-sector.service';
import { SegmentoSector } from '../../_models/segmento-sector';

@Component( {
  templateUrl: 'segmento-sector.component.html',
  selector: 'app-segmento-sector',
  providers: [ ConfirmationService ]
} )
export class SegmentoSectorComponent implements OnInit {
  @Input() detalle: boolean = false;
  columnas: any[];
  formulario: FormGroup;
  carSegmentoProducto: boolean;
  segmentoSectores: SegmentoSector[] = [];
  @Input()
  segmento: Segmento;
  @Input()
  segmentoTemp: any;
  submitted: boolean;
  guardando: boolean;
  listaSectores: SelectItem[];
  allSectores: ListaItem[];

  constructor( private navServicio: NavService,
               private router: Router,
               private formBuilder: FormBuilder,
               private segmentoSectorService: SegmentoSectorService,
               private productosService: ProductoService,
               private listaService: ListaService,
               private confirmacionServicio: ConfirmationService ) {
  }


  ngOnInit(): void {
    this.formulario = this.formBuilder.group( {
      idSector: [ null, [ Validators.required ] ],
      indicadorHabilitado: [ true ]
    } );

    this.columnas = [
      { field: 'nombreSector', header: this.navServicio.buscarMensaje( 'SEGMENTOSSECTOR.LBL_SECTOR' ), sort: true }
    ];
    if ( !this.detalle ) {
      this.columnas.push( { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false } );
    }
    forkJoin( this.listaService.getMasterDetails( 'ListasSectores' ),
      this.segmentoSectorService.obtenerPorSegmento( this.segmento.idSegmento ) ).subscribe( ( [ res1, res2 ] ) => {
      this.allSectores = res1;
      this.segmentoSectores = res2;
      this.carDropdown();
    }, ( err1 ) => {
      this.navServicio.setMesage( 4, {
        severity: 'error',
        summary: 'Error',
        detail: 'No se pudo cargar la información. Intente nuevamente.'
      } );
    } );
  }

  carDropdown(): void {
    this.listaSectores = [];
    this.allSectores.map( p => {
      if ( p.indicadorHabilitado && !this.segmentoSectores.find( sp => sp.indicadorHabilitado && sp.idSector === p.idLista ) ) {
        this.listaSectores.push( { label: p.nombre, value: p.idLista } );
      }
    } );
  }

  get f() {
    return this.formulario.controls;
  }

  get segSectores() {
    return this.segmentoSectores.filter( s => s.indicadorHabilitado );
  }

  onSubmit(): void {
    this.submitted = true;
    if ( this.formulario.valid ) {
      this.carSegmentoProducto = true;
      const temp: SegmentoSector = this.formulario.value;
      temp.idSegmento = this.segmento.idSegmento;
      temp.nombreSector = this.allSectores.find( p => p.idLista === temp.idSector ).nombre;
      const a = this.segmentoSectores.find( sp => sp.idSector === temp.idSector );
      if ( a ) {
        temp.idSegmentoSector = a.idSegmentoSector;
      }
      temp.indicadorHabilitado = true;
      if ( temp.idSegmentoSector ) {
        this.segmentoSectorService.actualizar( temp ).subscribe( res => {
          const tempSegmentoP: SegmentoSector[] = this.segmentoSectores;
          this.segmentoSectores = [];
          tempSegmentoP.map( t => {
            if ( t.idSegmentoSector === temp.idSegmentoSector ) {
              t.indicadorHabilitado = true;
            }
          } );
          this.segmentoSectores = tempSegmentoP;
          this.carDropdown();
          this.formulario.reset();
          this.submitted = false;
          this.carSegmentoProducto = false;
          this.navServicio.setMesage( 2 );
        } );
      } else {
        this.segmentoSectorService.agregar( temp ).subscribe( res => {
          temp.idSegmentoSector = res.idSegmentoSector;
          this.segmentoSectores.push( temp );
          this.carDropdown();
          this.formulario.reset();
          this.submitted = false;
          this.carSegmentoProducto = false;
          this.navServicio.setMesage( 1 );
        } );
      }
    } else {
      return;
    }
  }

  disable( row: SegmentoSector ): void {
    this.confirmacionServicio.confirm( {
      message: '¿Está seguro que desea inactivar este registro?',
      header: 'Sector',
      icon: 'fa fa-question-circle',
      key: 'sector',
      accept: () => {
        row.indicadorHabilitado = false;
        this.segmentoSectorService.actualizar( row ).subscribe( res => {
          const temp: SegmentoSector[] = this.segmentoSectores;
          this.segmentoSectores = [];
          temp.map( t => {
            if ( t.idSegmentoSector === row.idSegmentoSector ) {
              t.indicadorHabilitado = false;
            }
          } );
          this.segmentoSectores = temp;
          this.carDropdown();
        } );
      }
    });
  }
}
